module.exports = __webpack_public_path__ + "static/media/kashmirichickpeabowls.2ace7611.jpg";